exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".anchor{padding:2px;background-color:#eee;border:1px solid #ddd;color:#666;font-size:12px;line-height:12px}.anchor>input{margin-left:10px;background:transparent;border:none;color:#666}", ""]);

// exports
